import { Icon, IconName } from '@usealloy/component-library';
import React from 'react';

import type { OutputAttributeNode as IOutputAttributeNode, WorkflowNodeProps } from 'flow/service/graph';

import BaseNode from '../BaseNode';
import { getAttributeNodeIcon } from '../BaseNode/helpers';
import { useAppSelector } from '~/store/reduxHooks';
import { selectCustomTransactionAttributesEnabled } from '~/dashboard/views/workflows/store/redux/selectors/general';


function OutputAttributeNode(props: WorkflowNodeProps<IOutputAttributeNode>) {
  const { id, type, data: { label, isPublishedAttribute, objectType } } = props;

  const customTransactionAttributesEnabled = useAppSelector(
    selectCustomTransactionAttributesEnabled,
  );

  const iconName = getAttributeNodeIcon({
    defaultIcon: IconName.Output,
    isPublishedAttribute,
    objectType,
    customTransactionAttributesEnabled,
  });

  return (
    <BaseNode
      icon={
        <Icon icon={iconName} size="large" />
      }
      id={id}
      label={label}
      stateStyle={{
        baseBackgroundColor: 'var(--cl-juicyBlue-100)',
        highlighted: {
          backgroundColor: 'var(--cl-juicyBlue-300)',
        },
        hovered: {
          backgroundColor: 'var(--cl-juicyBlue-300)',
        },
      }}
      type={type}
    />
  );
}

export default React.memo(OutputAttributeNode);
